import React, { useCallback, useEffect, useState } from 'react';
import { api, API_ROUTERS } from '../../../services/api';
import Store, { useAppDispatch } from '../../../store';
import { hojeLocal } from '../../../utils/data';
import ConferenciaDiaView from './view';
import { EntregadorCadastrado, NotaDoDia } from './types';

/**
 * Conferencia do dia.
 *
 * Cruza as notas do dia (GET /api/nota?data=) com os entregadores
 * CADASTRADOS: sem a segunda lista, o motorista que ficou sem manifesto
 * simplesmente nao apareceria no relatorio.
 */
const ConferenciaDiaContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState(hojeLocal());
  const [notas, setNotas] = useState<NotaDoDia[]>([]);
  const [entregadores, setEntregadores] = useState<EntregadorCadastrado[]>([]);
  const [erro, setErro] = useState('');
  const [filtrosAbertos, setFiltrosAbertos] = useState(true);

  const carregar = useCallback(
    async (dia: string) => {
      try {
        setErro('');
        Store.load.show(dispatch, 'Consultando notas do dia');

        const [notasDoDia, listaEntregadores] = await Promise.all([
          api.get(`${API_ROUTERS.NOTA}?data=${dia}`),
          api.get(API_ROUTERS.ENTREGADORES),
        ]);

        setNotas(api.utils.trataResponseArray(notasDoDia) as NotaDoDia[]);
        setEntregadores(
          api.utils.trataResponseArray(listaEntregadores) as EntregadorCadastrado[]
        );
      } catch (err) {
        console.error('Erro ao carregar a conferência do dia:', err);
        setErro(
          'Não foi possível carregar as notas do dia. Tente novamente.'
        );
      } finally {
        Store.load.hide(dispatch);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    carregar(data);
  }, [carregar, data]);

  const trocarData = (novaData: string) => {
    // trocar a data E a consulta desta tela: recolhe os filtros
    setFiltrosAbertos(false);
    setData(novaData);
  };

  return (
    <ConferenciaDiaView
      data={data}
      notas={notas}
      entregadores={entregadores}
      erro={erro}
      filtrosAbertos={filtrosAbertos}
      onToggleFiltros={() => setFiltrosAbertos((aberto) => !aberto)}
      onTrocarData={trocarData}
    />
  );
};

export default ConferenciaDiaContainer;
